import React, { useState } from 'react';
import HomesliderServices from '../../services/HomeSliderServices';

import BreedServices from '../../services/BrandServices.js';
import UserServices from '../../services/UserServices.js';
import PlanServices from '../../services/PlanServices.js';
import CarServices from '../../services/CarServices.js';
import FeedbackServices from '../../services/FeedbackServices.js';
import BrandServices from '../../services/BrandServices.js';
import VehicleServices from '../../services/VehicleServices.js';
import AddonsServices from '../../services/AddonsServices.js';
import CoupanServices from '../../services/CoupanServices.js';
import LocationServices from '../../services/LocationServices.js';
import HappyCustomerServices from '../../services/HappyCustomerServices.js';

const TogalButtonForStatus = ({ data, page ,onSuccess}) => {
  const [isChecked, setIsChecked] = useState(data?.status === 'Active');

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Active' : 'Inactive'; 
    setIsChecked(!isChecked);
     if (page === 'service') {
      const res = await CarServices.updateService(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'brand') {
      const res = await BrandServices.updateBrand(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'happy') {
      const res = await HappyCustomerServices.updateHappy(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'Location') {
      const res = await LocationServices.updateLocation(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'Addons') {
      const res = await AddonsServices.updateAddons(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'Coupan') {
      const res = await CoupanServices.updateCoupanStatus(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'vehicle') {
      const res = await VehicleServices.updateVehicle(data._id, {
        status: newStatus
      });
      onSuccess();
    }
   
    else if (page === 'user') {
      const res = await UserServices.updateUserStatus(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'feedback') {
      const res = await FeedbackServices.updateFeedbackStatus(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'vendor') {
      const res = await UserServices.updateVendorStatus(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'plan') {
      const res = await PlanServices.updatePlan(data._id, {
        status: newStatus
      });
      onSuccess();
    }
    else if (page === 'breed') {
      const res = await BreedServices.updateBreed(data._id, {
        status: newStatus
      });
      onSuccess();
    } 
  
   
  
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default TogalButtonForStatus;
